import { bartenderService } from "./BartenderService";

export default bartenderService;
